<template>
  <div class=" is-fullwidth">
    <div class="container is-fullwidth is-pulled-right">
        <div class="columns">
          <div class="col">
        <input class="input" v-model="search" placeholder="search orders ..."/>
          </div>
          
           
          </div>
          <br />
    </div>

    <table class="table is-hoverable is-fullwidth " id="orderstable">
    	<thead>
         <th width="60">&nbsp;</th>
    		<th>PO Number</th>
        <th>&nbsp;</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Qty</th>
          <th>CAD ID</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th v-if="1==2">New/Repeat</th>
          <th v-if="1==2">Artwork Location</th>
          <th v-if="1==2">Process</th>
          <th v-if="1==2">Artworker</th>
         
          <th width="">&nbsp;</th>
          
    	</thead>
    	<tbody>
             <tr v-if="loading === true">
                <td colspan="9" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="9" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
		    <tr v-for="(order, index) in filteredOrders" v-bind:key="order.orderID">
          <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
          <td ><router-link :to="'/digitalprint/view-order?ponumber=' + order.ponumber">{{order.ponumber}}</router-link></td>
          <td>
            <span v-if="order.attachments.length > 0"><i class="fa fa-folder" aria-hidden="true" @click="showAttachments(order)"></i></span>
          </td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname.replace("Personalised ", "")}}
            <OrderTypeTag :order="order"/>
          </td>
          <td>{{ order.total_qty }}</td>
           <td>{{order.cad_id}}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td  v-if="1==2">
                 <div class="buttons has-addons ">
                  <button class="button is-small" :class="[order.artwork_new== 1 ? 'is-success' : '']" @click="order.artwork_new=1;order.artwork_repeat=0;">New</button>
                  <button class="button is-small " :class="[order.artwork_repeat== 1 ? 'is-warning' : '']" @click="order.artwork_repeat=1;order.artwork_new=0;">Repeat</button>
                  
                </div>
              </td>
          <td  v-if="1==2">
                 <div class="buttons has-addons ">
                  <button class="button is-small" :class="[order.artwork_location_id=== 1 ? 'is-success' : '']" @click="order.artwork_location_id=1">Strabane</button>
                  <button class="button is-small " :class="[order.artwork_location_id=== 2 ? 'is-success' : '']" @click="order.artwork_location_id=2">Giurgiu</button>
                  
                </div>
              </td>
              <td  v-if="1==2">
                 <div class="buttons has-addons " v-if="order.artwork_repeat===1">
                  <button class="button is-small" :class="[order.artwork_gemini=== 1 ? 'is-success' : '']" @click="order.artwork_gemini=1">Gem.</button>
                  <button class="button is-small " :class="[order.artwork_standard=== 1 ? 'is-success' : '']" @click="order.artwork_standard=1">Std</button>
                  <button class="button is-small " :class="[order.artwork_nested=== 1 ? 'is-success' : '']" @click="order.artwork_nested=1">Nest</button>
                  
                </div>
                 <div class="buttons has-addons " v-if="order.artwork_new===1">
                  <button class="button is-small" :class="[order.artwork_gemini=== 1 ? 'is-success' : '']" @click="order.artwork_gemini=1">Gemini</button>
                  
                </div>
              </td>
              <td  v-if="1==2">
                <div class="select is-small">
                 <select class="">
                     <option value="">Please select</option>
                     <option value="">David Hynes</option>
                     <option value="">Alan Atkinson</option>
                     <option value="">Aaron McAdams</option>

            </select>
            </div>
              </td>
              
              <td >
                  <button class="button is-small is-success" @click="openProcessModal(index)" :disabled="working===true" v-if="artworkManager == true && order.deliverydate_iso > '2023-01-01'">Process</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" v-if="1===2">Export</button>
    
    <OrderModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"/>


    
    <div class="modal " v-bind:class="{ 'is-active' : showProcessModal} ">
      <div class="modal-background"></div>
      <div class="modal-card process">
        <header class="modal-card-head">
          <p class="modal-card-title">Process Order</p>
          <button class="delete" aria-label="close" @click="showProcessModal=false"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
              <div class="column is-three-quarters"><img :src="'https://www.oneillsonline.com/images/historical/' + selected_order.garmentimage" /></div>
              <div class="column is-one-quarter">
                <p>Artwork Type</p>
                <div class="buttons has-addons ">
                  <button class="button is-small " :class="[selected_order.artwork_new== 1 ? 'is-success' : '']" @click="selected_order.artwork_new=1;selected_order.artwork_repeat=0;">New</button>
                  <button class="button is-small " :class="[selected_order.artwork_repeat== 1 ? 'is-warning' : '']" @click="selected_order.artwork_repeat=1;selected_order.artwork_new=0;">Repeat</button>
                  
                </div>

                <p>Print Location</p>
                 <div class="buttons has-addons ">
                  <button class="button is-small " :class="{'is-success' : selected_order.print_location_id==row.id}" @click="selected_order.print_location_id=row.id" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                  
                </div>

                <p>Process</p>
                <div class="buttons has-addons " >
                  <button class="button is-small " :class="{'is-success' : selected_order.artwork_gemini == 1}" @click="selected_order.artwork_gemini=1;selected_order.artwork_standard=0;selected_order.artwork_nested=0">Gemini</button>
                  <button class="button is-small " :class="{'is-info' : selected_order.artwork_standard == 1}" @click="selected_order.artwork_gemini=0;selected_order.artwork_standard=1;selected_order.artwork_nested=0">Standard</button>
                  <button class="button is-small " :class="{'is-warning' : selected_order.artwork_nested == 1}" @click="selected_order.artwork_gemini=0;selected_order.artwork_standard=0;selected_order.artwork_nested=1">Nested</button>
                  
                </div>

                <p>Artworker (Not Required)</p>
                  <div class="select is-small">
                    <select class="select" v-model="selected_order.artworker_user_id">
                        <option value="0">Please select</option>
                        <option v-bind:value="row.userID" v-for="row in artworkers" :key="row.userID">{{ row.firstname }} {{row.surname }}</option>
                       
                </select>
                </div>
                <br /><br />
                <p>  <button class="button is-success" @click="processOrder()" v-if="selected_order.artwork_new == 1 || selected_order.artwork_repeat == 1">Process Order</button></p>
              
              </div>
            </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="showProcessModal=false">Cancel</button>
        </footer>
      </div>
    </div>

    <div class="modal " v-bind:class="{ 'is-active' : showAttachmentsModal} ">
      <div class="modal-background"></div>
      <div class="modal-card process">
        <header class="modal-card-head">
          <p class="modal-card-title">Order Attachments</p>
          <button class="delete" aria-label="close" @click="showAttachmentsModal=false"></button>
        </header>
        <section class="modal-card-body">
          
             
                <table class="table is-striped is-fullwidth">
                  <thead>
                    <tr>
                      <th>Filename</th>
                      <th>Date Added</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in selectedOrder.attachments" :key="row.id">
                        <td><a :href="ASP_URL + '/uploads/orders/' + selectedOrder.orderID + '/' + row.filename" target="_blank">{{ row.filename}}</a></td>
                        <td>{{ row.date_added}}</td>
                      </tr>
                      
                    </tbody>
                </table>
             
            
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="showAttachmentsModal=false">Close</button>
        </footer>
      </div>
    </div>
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderModal from '@/components/OrderModal';
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

import OrderTypeTag from '@/components/Generic/OrderTypeTag.vue';


export default {
  components: {
   	OrderModal,
     OrderTypeTag
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      showProcessModal:false,
      selectedOrderID: 0,
      working :false,
      loading:true,
      selected_order: [ {'garmentimage' : '', 'artworker_user_id': 0}],
      locations: [],
      artworkers: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      order_by: 'orderdate DESC',
      search: '',
      showAttachmentsModal: false,
      selectedOrder: []
      
    }
  },
   methods: {
      showAttachments(order)
      {

        this.selectedOrder = order
        this.showAttachmentsModal = true
      },
      async getOrders() {
        this.loading=true
        OrderService.getIncomingArtworkOrders(this.accessToken, "", this.order_by, 0)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1").then(
               response => this.locations = response 
            );
      },
      async getArtworkers() {
        UtilityService.getSimpleApiData(this.accessToken, "users?artworker=1").then(
               response => this.artworkers = response 
            );
      },
    
      exportXLS() {
      //alert("hi")
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet JS"});
      XLSX.writeFile(wb, 'book.xlsx')

    },
    openProcessModal(index)
    {
      this.selected_order = this.filteredOrders[index]
      this.showProcessModal=true
    },

    async processOrder() {
        this.working = true

        var formdata = { 
            _method: 'patch',
            artwork_new: this.selected_order.artwork_new,
              artwork_repeat: this.selected_order.artwork_repeat,
              artworker_user_id: this.selected_order.artworker_user_id,
              print_location_id: this.selected_order.print_location_id,
              artwork_gemini: this.selected_order.artwork_gemini,
              artwork_standard: this.selected_order.artwork_standard,
              artwork_nested: this.selected_order.artwork_nested,
        }; 

        OrderService.updateOrder(this.accessToken, this.selected_order.orderID, formdata)
        .then(() => {
            this.working = false

            this.selected_order.artwork_repeat = 1
            this.selected_order.processed = 1
            this.showProcessModal=false

            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
            this.showProcessModal=false
        });

        
    }
    
  },
  computed : {
     filteredOrders: function () {
       // let filteredOrders = []
        //let filteredOrders = this.orders
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.processed == 0) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     artworkManager: function() {
       return this.$auth.user.roles.includes("Artwork Manager")
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
           this.getArtworkers();
        });

        
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    },
  }
}


</script>

<style scoped>
  .modal-card.process  {width:1280px}
</style>

